<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo de Servicio - Nuevo</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" @submit.prevent="Validate">
              <b-row>

                <b-col md="3">
                  <b-form-group>
                    <b-card-img :src="url_base + '/img/default.jpg'"></b-card-img>
                  </b-form-group>
                  <b-form-group>
                    <b-form-file @change="onFileChange" accept="image/*" v-model="photo" placeholder="Seleccione un foto..." drop-placeholder="Suelta la imagen aquí..."></b-form-file>
                    <small v-if="errors.photo" class="form-text text-danger">Seleccione un foto</small>
                  </b-form-group>
                </b-col>

                <b-col md="9">
                  <b-row>

                        <b-col md="10">
                          <b-form-group label="Nombre:">
                            <b-form-input  type="text" v-model="service.name" ></b-form-input>
                            <small v-if="errors.name" class="form-text text-danger">Ingrese un nombre</small>
                          </b-form-group>
                        </b-col>

                        <b-col md="2">
                          <b-form-group label="Estado:">
                            <b-form-select v-model="service.state" :options="state"></b-form-select>
                          </b-form-group>
                        </b-col>

                        
                        <b-col md="5"></b-col>
                        <b-col md="2">
                          <b-button type="submit" class="form-control"  variant="primary" ><i class="fas fa-save"></i> Guardar (F4)</b-button >
                        </b-col>

                  </b-row>

                </b-col>
                
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>


    <LoadingComponent :is-visible="isLoading"/>
    <Keypress key-event="keyup" :key-code="115" @success="Validate" />
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import LoadingComponent from './../pages/Loading'
export default {
  name: "UsuarioAdd",
  components:{
      Keypress: () => import('vue-keypress'),
      LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: "Service",
      role: 2,
      service: {
        id_service: "",
        name: "",
        photo: "",
        state: 1,
      },
      photo: null,
      state:[
        {value:0,text:'Inactivo'},
        {value:1,text:'Activo'},
      ],
      
      errors: {
        name: false,
      },
      validate: false,
    };
  },
  mounted() {
    
  },
  methods: {
    onFileChange,
    AddService,
    Validate,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function onFileChange(e) {
  this.service.photo = e.target.files[0];
}

function AddService(me) {
  let url = me.url_base + "service/add";
  let data = new FormData();
  data.append("name", this.service.name);
  data.append("photo", this.service.photo);
  data.append("state", this.service.state);
  me.isLoading = true;
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: 2,},
  })
    .then(function (response) {
      if (response.data.status == 201) {
        me.service.name = "";
        me.service.photo = "";
        me.service.state = 1;
        me.photo = null;
        Swal.fire({ icon: 'success', text: 'Se ha registrado el servicio', timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
      me.isLoading = false;
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}

/**
 * 
 */
function Validate() {

  this.errors.name = this.service.name.length == 0 ? true : false;

  if (this.errors.name) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }

  let me = this;

  if (!this.validate) {
    Swal.fire({
      title: "Esta seguro de registrar el servicio ?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Estoy de acuerdo!",
    }).then((result) => {
      if (result.value) {
        this.AddService(me);
      }
    });

  }

}
</script>
